import { render, staticRenderFns } from "./addHotProduct.vue?vue&type=template&id=d8e68638&scoped=true"
import script from "./addHotProduct.vue?vue&type=script&lang=js"
export * from "./addHotProduct.vue?vue&type=script&lang=js"
import style0 from "./addHotProduct.vue?vue&type=style&index=0&id=d8e68638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e68638",
  null
  
)

export default component.exports